module.exports = __webpack_public_path__ + "img/t-shirt-icon.8e2a8c1d.svg";